var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.274 6.673-.003-.004a.995.995 0 0 0-1.408-.049l-1.021.957A.5.5 0 0 1 11 7.212V1a1 1 0 1 0-2 0v6.197a.5.5 0 0 1-.845.361l-.974-.928a.994.994 0 1 0-1.367 1.441l2.848 2.688a2 2 0 0 0 2.753-.006l2.816-2.686a.993.993 0 0 0 .043-1.394zM20 18.222C20 19.2 19.32 20 17.888 20H1.778A1.778 1.778 0 0 1 0 18.222v-6.445C0 10.847.707 10 1.888 10h1.119c.548 0 .993.444.993.993v.013a.994.994 0 0 1-.993.994h-.014a.993.993 0 0 0-.993.993v4.013c0 .549.445.994.993.994h14.014a.994.994 0 0 0 .993-.994v-4.013a.993.993 0 0 0-.993-.993h-.014a.994.994 0 0 1-.993-.994v-.013c0-.549.445-.993.993-.993h1.229c.982 0 1.778.796 1.778 1.777v6.445z",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.70c5a3f1.svg";
export { ForwardRef as ReactComponent };